export const baseColumnsDefaultConfigs = [
  {
    id: 'name',
    width: 150,
    pinned: false,
    index: 0,
    minWidth: 70,
    sorted: 'descending',
  },
  {
    id: 'dimensions',
    width: 100,
    pinned: false,
    index: 1,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'weight',
    width: 100,
    pinned: false,
    index: 2,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'domesticProvider',
    width: 100,
    pinned: false,
    index: 3,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'domesticService',
    width: 100,
    pinned: false,
    index: 4,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'domesticPackage',
    width: 100,
    pinned: false,
    index: 5,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'domesticConfirmation',
    width: 100,
    pinned: false,
    index: 6,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'internationalProvider',
    width: 100,
    pinned: false,
    index: 7,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'internationalService',
    width: 100,
    pinned: false,
    index: 8,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'internationalPackage',
    width: 100,
    pinned: false,
    index: 9,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'internationalConfirmation',
    width: 100,
    pinned: false,
    index: 10,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'actions',
    width: 100,
    pinned: false,
    index: 11,
    minWidth: 70,
    nonsortable: true,
  },
];
